import { useEffect } from 'react'
import { useDarkMode } from '../contexts/DarkModeContext'
import { getAccountSettings } from '../api'

export const DarkModeSync = () => {
    const { syncFromApi } = useDarkMode()

    useEffect(() => {
        const sync = async () => {
            try {
                const token = undefined
                const settings = await getAccountSettings(token)
                syncFromApi(settings.darkMode)
            } catch (err) {
                console.error('Error syncing dark mode:', err)
            }
        }
        sync()
    }, [syncFromApi])

    return null
}
